import { languageOptions } from '../Translations/LanguageOptions';

export function localeMapper(locale) {
  const map = {
    pt: 'pt-BR',
    zh: 'zh-Hans',
  };

  return map[locale] || locale;
}

export const localeOptions = languageOptions.map(l => ({ text: l.translationKey, value: localeMapper(l.key) }));

export function localeTextByValue(value) {
  const locale = localeOptions.find(obj => obj.value === value);
  if (locale) {
    return locale.text;
  }

  if (value === 'es-ES') {
    return 'language:spanish';
  }

  return '';
}

export function storeLocale(value) {
  localStorage.setItem('currentLocale', localeMapper(value));
}

export function getLocale() {
  return localStorage.getItem('currentLocale');
}
